





















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

export default {
  props: ['content'],
};

